import { CardMedia, Grid, Typography, Stack, Box } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import { clearData, getData, storeData } from "../utils/GlobalHelper";
import GlobalApi from "../utils/GlobalApi";
import { isEmpty } from "lodash";
import Loading from "../components/loading/loading";
import HeaderRight from "../components/BoxRightContent/HeaderRight";
import ButtonRight from "../components/BoxRightContent/ButtonRight";
import ScrollBarComponent from "../components/BoxRightContent/ScrollBarComponent";
const Index = (props) => {
  const mb = isMobile ? 16 : 9;
  const [lang, setLang] = useState("");
  const [translations, setTranslations] = useState("");
  const [en, setEn] = useState({});
  const [th, setTh] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [documentsNeeded, setDocumentsNeeded] = useState([]);
  const [applicantQualifications, setApplicantQualifications] = useState([]);

  const clearLocalstorage = () => {
    var keys_lock = [
      "_secure__ls__metadata",
      "lang",
      "api_error",
      "Translations",
      "aecode",
    ];
    var keys = Object.keys(localStorage),
      i = keys.length;
    while (i--) {
      if (!keys_lock.includes(keys[i])) {
        clearData(keys[i]);
      }
    }
  };
  const apiLang = async (type) => {
    try {
      setIsLoading(true);
      await GlobalApi.get("/data/mock/" + type + "_response.json")
        .then((res) => {
          if (type === "en") {
            setEn(res?.data);
          } else if (type === "th") {
            setTh(res?.data);
          }
          setIsLoading(false);
        })
        .catch((er) => {
          setIsLoading(false);
          // console.log(er);
        });
    } catch (err) {
      setIsLoading(false);
      // console.log(err);
    }
  };
  const handleNext = () => {
    //TODO function nextPage
    props.history.push("/checkuserinfo");
  };

  useEffect(() => {
    if (!isEmpty(en) && !isEmpty(th)) {
      storeData("Translations", { en: en, th: th });
      setTranslations({ en: en, th: th });
    }
  }, [en, th]);
  useEffect(async () => {
    clearLocalstorage();

    storeData("lang", "th");
    await apiLang("th");
    await apiLang("en");
    setLang("th");
    const fetchedTranslations = getData("Translations");
    setTranslations(fetchedTranslations);
    let url_string = window.location.href;
    let url = new URL(url_string);
    let aecode_form_url = url.searchParams.get("aecode")
      ? url.searchParams.get("aecode")
      : "";
    let aecode_localstorage = getData("aecode") ? getData("aecode") : "";
    let HaveAe = getData("HaveAe") ? getData("HaveAe") : false;
    if (aecode_form_url === "") {
      if (HaveAe) {
        clearData("HaveAe");
        if (aecode_localstorage !== "") {
          const urlParams = new URLSearchParams(window.location.search);
          urlParams.set("aecode", aecode_localstorage);
          window.location.search = urlParams;
        }
      } else {
        clearData("aecode");
      }
    } else {
      storeData("aecode", aecode_form_url);
    }
    const documents_needed =
      fetchedTranslations?.["th"]?.home?.requirements?.documents_needed;
    const applicant_qualifications =
      fetchedTranslations?.["th"]?.home?.requirements?.applicant_qualifications;
    setDocumentsNeeded(documents_needed);
    setApplicantQualifications(applicant_qualifications);
  }, []);
  return (
    <>
      <HeaderPage
        comeback
        title={translations?.[lang]?.home?.title}
        onChangeLang={(e) => setLang(e)}
      />
      <Loading status={isLoading} />
      <Grid className="background-bg">
        <Grid className="section-consent">
          <Grid className={isMobile ? "box-content-mb" : "box-content"}>
            <Grid container className="box-content-main" columns={16}>
              {!isMobile && (
                <Grid item xs={7} className="box-left">
                  <BoxLeftContent translations={translations?.[lang]} isHome />
                </Grid>
              )}
              <Grid
                item
                xs={mb}
                className={isMobile ? "box-right-mb" : "box-right"}
              >
                <Grid className="content">
                  <Grid className="content-main ">
                    <Grid
                      className="box-right-content pb-3"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                      }}
                    >
                      <ScrollBarComponent
                        content={
                          <Grid>
                            <Grid
                              className={
                                isMobile ? "box-image-mb" : "box-image"
                              }
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <CardMedia
                                  component="img"
                                  // className="img-content"
                                  sx={{
                                    width: "90%",
                                  }}
                                  image={
                                    isMobile
                                      ? "../../../images/Banner_OA-App_Mobile.png?v=1.0"
                                      : "../../../images/Banner_OA-App.png?v=1.0"
                                  }
                                  alt="NDID"
                                />
                              </Box>
                            </Grid>
                            <div className="requirements-page">
                              {/* Documents Needed Section */}
                              {documentsNeeded && (
                                <section className="requirements-section  pt-3">
                                  <Typography
                                    gutterBottom
                                    align="center"
                                    sx={{
                                      color: "#023b66",
                                      mb: 0.25,
                                      fontSize: 24,
                                    }}
                                  >
                                    {documentsNeeded.title}
                                  </Typography>
                                  <Stack
                                    direction="row"
                                    flexWrap="wrap"
                                    justifyContent={"space-around"}
                                    gap={isMobile ? 1 : 1}
                                    component="ul"
                                    sx={{ listStyle: "none", p: 0, m: 0 }}
                                  >
                                    {documentsNeeded.items?.map((item) => (
                                      <Box
                                        key={item.param}
                                        component="li"
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "center",
                                          textAlign: "center",
                                          gap: 0.5,
                                          minWidth: isMobile ? "45%" : "22%", // ✅ เปลี่ยนจาก "22%" เป็น "45%" ให้ได้ 2 คอลัมน์
                                        }}
                                      >
                                        {item.icon && (
                                          <Box
                                            component="img"
                                            src={`../../../images/${item.icon}.png?v=1.0`}
                                            alt={item.label}
                                            width={isMobile ? 60 : 70}
                                          />
                                        )}
                                        <Typography
                                          variant="body2"
                                          className="requirement-label"
                                          sx={{
                                            color: "gray",
                                            fontWeight: "normal !important",
                                            mb: 0.25,
                                            fontSize: isMobile ? 20 : 22,
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html: item.label,
                                          }}
                                        ></Typography>
                                      </Box>
                                    ))}
                                  </Stack>
                                </section>
                              )}

                              {/* Applicant Qualifications Section */}
                              {applicantQualifications && (
                                <section className="requirements-section pt-3">
                                  <Typography
                                    gutterBottom
                                    align="center"
                                    sx={{
                                      color: "#023b66",
                                      mb: 0.25,
                                      fontSize: 24,
                                    }}
                                  >
                                    {applicantQualifications.title}
                                  </Typography>
                                  <ul
                                    className="requirements-list"
                                    style={{
                                      marginTop: 0,
                                      paddingLeft: 20,
                                    }}
                                  >
                                    {applicantQualifications.items?.map(
                                      (item) => (
                                        <Box
                                          component="li"
                                          key={item.param}
                                          className="requirement-item"
                                          sx={{
                                            "&::marker": {
                                              color: "gray",
                                            },
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            className="requirement-label"
                                            sx={{
                                              color: "gray",
                                              fontWeight: "normal !important",
                                              mb: 0.25,
                                              fontSize: isMobile ? 20 : 22,
                                            }}
                                          >
                                            {item.label}
                                          </Typography>
                                        </Box>
                                      ),
                                    )}
                                  </ul>
                                </section>
                              )}
                            </div>
                          </Grid>
                        }
                      />
                      <ButtonRight
                        text={"เริ่มเปิดบัญชี"}
                        onNextPage={handleNext}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default memo(Index);
